import React, { useEffect, useState } from 'react';
import '../../styles/newhome.css';
import '../../styles/landing-fonts.css';
import { getContactConfigs } from '../../services/configService';
import footerBg from '../../Landing organization/uploads/mimt/assets/images/footer-bg.webp';

// If you already have these helpers in utils, import instead of defining here
const unwrapPayload = (payload) => payload;

const extractValue = (config, keys) => {
  for (let key of keys) {
    if (config?.[key]) return config[key];
  }
  return null;
};

const buildSocialLink = (value, type) => {
  if (!value) return null;
  switch (type) {
    case 'telegram': return `https://t.me/${value}`;
    case 'whatsapp': return `https://wa.me/${value}`;
    case 'instagram': return `https://instagram.com/${value}`;
    case 'email': return `mailto:${value}`;
    default: return value;
  }
};

const Footer = ({ force = false }) => {
  const shouldSkip = (!force && typeof document !== 'undefined' && document && document.body && document.body.dataset && document.body.dataset.globalFooter === '1');
  const [contactInfo, setContactInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};
  useEffect(() => {
    if (shouldSkip) return;
    const fetchConfigs = async () => {
      try {
        setLoading(true);
        const payload = await getContactConfigs();
        const configs = unwrapPayload(payload);
        const primaryConfig = Array.isArray(configs?.items) && configs.items.length > 0
          ? configs.items[0]
          : configs;

        const info = {
          about: extractValue(primaryConfig, ['about', 'about']),
          footer: extractValue(primaryConfig, ['footer', 'footer']),
          address: extractValue(primaryConfig, ['address', 'O�O_O�O3']),
          phone: extractValue(primaryConfig, ['phone', 'tel', 'O�U,U?U+']),
          mobile: extractValue(primaryConfig, ['mobile', 'U.U^O"O\u0015UOU,']),
          telegram: extractValue(primaryConfig, ['telegram', 'O�U,U_O�O\u0015U.']),
          eitaa: extractValue(primaryConfig, ['eitaa', 'O�U,U_O�O\u0015U.']),
          whatsapp: extractValue(primaryConfig, ['whatsapp', 'U^O\u0015O�O3O\u0015U_', 'U^O\u0015O�O3 O\u0015U_', 'U^O\u0015O�O3�?OO\u0015U_']),
          instagram: extractValue(primaryConfig, ['instagram', 'O\u0015UOU+O3O�O\u0015U_O�O\u0015U.']),
          email: extractValue(primaryConfig, ['email', 'O\u0015UOU.UOU,']),
        };

        setContactInfo(info);
        setError(false);
      } catch (err) {
        console.error('Failed to load contact configs', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchConfigs();
  }, [shouldSkip]);

  if (shouldSkip) {
    return null;
  }
  return (
  
    <footer className="footer" style={{ backgroundImage: `url(${footerBg})` }}>
      <div className="container">
        <div className="row">
         <div className="col-lg-4 col-md-6" dangerouslySetInnerHTML={{ __html: contactInfo.footer }} />
          <div className="col-lg-4 col-md-6">
            <h5 className="footer__title">ارتباط با ما</h5>
            <div className="contact">
              {contactInfo.address && (
                <div className="contact__item">
                  <i className="niafam niafam-map1"></i>
                  <p>{contactInfo.address}</p>
                </div>
              )}
              {(contactInfo.phone || contactInfo.mobile) && (
                <div className="contact__item">
                  <i className="niafam niafam-call"></i>
                  <p>
                    {contactInfo.phone ? `تلفن: ${contactInfo.phone}` : ''}
                    {contactInfo.phone && contactInfo.mobile ? ' | ' : ''}
                    {contactInfo.mobile ? `موبایل: ${contactInfo.mobile}` : ''}
                  </p>
                </div>
              )}
              {contactInfo.email && (
                <div className="contact__item">
                  <i className="niafam niafam-email-2"></i>
                  <p>ایمیل: <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a></p>
                </div>
              )}
              {contactInfo.eitaa && (
                <div className="contact__item">
                  {/* <i className="niafam niafam-email-2"></i> */}
                  <span className="fa-eitaa  w-20px h-20px" />
                  <p>ایتا: <a href={buildSocialLink(contactInfo.eitaa, 'eitaa')}>{contactInfo.eitaa}</a></p>
                </div>
              )}
            </div>
            {/* Socials just under email */}
            <ul className="socialmedia">
              {contactInfo.instagram && (
                <li><a href={buildSocialLink(contactInfo.instagram, 'instagram')} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram"></i></a></li>
              )}
              {contactInfo.telegram && (
                <li><a href={buildSocialLink(contactInfo.telegram, 'telegram')} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-telegram"></i></a></li>
              )}
              
              {contactInfo.whatsapp && (
                <li><a href={buildSocialLink(contactInfo.whatsapp, 'whatsapp')} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp"></i></a></li>
              )}
              {/* {contactInfo.email && (
                <li><a href={buildSocialLink(contactInfo.email, 'email')}><i className="fa-solid fa-envelope"></i></a></li>
              )} */}
            </ul>
          </div>
          <div className="col-lg-4 d-none d-lg-block">
            <iframe
              className="map-embed"
              title="company-location"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://maps.google.com/maps?q=35.70503798648378, 51.41471873749741&z=14&output=embed`}
            />
          </div>
          <div className="col-12" style={{fontSize: "1em"}}>
                            <div className="copyright" style={{fontSize: "1em"}}>
                                <p className="copyright__text" style={{fontSize: "0.75em"}}>{contactInfo.about}.</p>
                            </div>
                        </div>
        </div>
      </div>
    </footer>

    
  );
};

export default Footer;
